import { gsap } from 'gsap';

export const paperPlaneAnimation = button => {
  const getVar = variable => getComputedStyle(button).getPropertyValue(variable);
  gsap.to(button, {
    keyframes: [
      {
        '--background': 'transparent',
        '--box-shadow': 'none',
        duration: 0
      },
      {
        '--width': '144px',
        '--left-wing-first-x': '50%',
        '--left-wing-first-y': '100%',
        '--right-wing-second-x': '50%',
        '--right-wing-second-y': '100%',
        duration: 0.2,
        onComplete() {
          gsap.set(button, {
            '--left-wing-first-y': '0%',
            '--left-wing-second-x': '40%',
            '--left-wing-second-y': '100%',
            '--left-wing-third-x': '0%',
            '--left-wing-third-y': '100%',
            '--left-body-third-x': '40%',
            '--right-wing-first-x': '50%',
            '--right-wing-first-y': '0%',
            '--right-wing-second-x': '60%',
            '--right-wing-second-y': '100%',
            '--right-wing-third-x': '100%',
            '--right-wing-third-y': '100%',
            '--right-body-third-x': '60%'
          });
        }
      },
      {
        '--left-wing-third-x': '20%',
        '--left-wing-third-y': '90%',
        '--left-wing-second-y': '90%',
        '--left-body-third-y': '90%',
        '--right-wing-third-x': '80%',
        '--right-wing-third-y': '90%',
        '--right-body-third-y': '90%',
        '--right-wing-second-y': '90%',
        duration: 0.2
      },
      {
        '--rotate': '50deg',
        '--left-wing-third-y': '95%',
        '--left-wing-third-x': '27%',
        '--right-body-third-x': '45%',
        '--right-wing-second-x': '45%',
        '--right-wing-third-x': '60%',
        '--right-wing-third-y': '83%',
        duration: 0.25
      },
      {
        '--rotate': '60deg',
        '--plane-x': '-8px',
        '--plane-y': '40px',
        duration: 0.2
      },
      {
        '--rotate': '40deg',
        '--plane-x': '45px',
        '--plane-y': '-300px',
        '--plane-opacity': 0,
        duration: 0.375
      }
    ]
  });

  gsap.to(button, {
    keyframes: [
      {
        '--text-opacity': 0,
        '--left-wing-background': getVar('--plane-color-dark'),
        '--right-wing-background': getVar('--plane-color-dark'),
        duration: 0.1
      },
      {
        '--left-wing-background': getVar('--plane-color'),
        '--right-wing-background': getVar('--plane-color'),
        duration: 0.15
      },
      {
        '--left-body-background': getVar('--plane-color-dark'),
        '--right-body-background': getVar('--plane-color-darkest'),
        duration: 0.25,
        delay: 0.1
      },
      {
        '--trails-stroke': '171px',
        duration: 0.22,
        delay: 0.22,
        onComplete() {
          button.classList.add('done');
          button.disabled = true;
          gsap.to(button, {
            '--background': getVar('--dark-20'),
            delay: 0.1
          });
        }
      },
      {
        '--width': '100%',
        delay: 0.2
      },
      {
        '--progress-opacity': 1,
        '--progress-y': '0px',
        duration: 0.2,
        delay: 0.15
      },
      {
        '--progress-stroke': '0px',
        duration: 0.15
      }
    ]
  });
};

export const paperPlaneAnimationDone = button => {
  gsap.set(button, {
    keyframes: [
      {
        '--progress-opacity': 0,
        '--progress-y': '8px',
        duration: 0.2,
        delay: 0.15
      },
      {
        '--success-opacity': 1,
        '--success-y': '0px',
        '--success-stroke': '0px',
        duration: 0.2,
        delay: 0.15
      }
    ]
  });
};
